<template>
	<v-layout class="bo-input">
		<checkbox-input
			ref="input"
			v-if="input.type === 'checkbox'"
			:required="input.required"
			:disabled="input.disabled"
			:label="input.label"
			:hint="input.hint"
			:rules="input.rules"
			@change="update"
			v-model="model"
		></checkbox-input>

		<checkbox-with-null-input
			ref="input"
			v-if="input.type === 'checkboxWithNull'"
			:required="input.required"
			:disabled="input.disabled"
			:label="input.label"
			:rules="input.rules"
			:hint="input.hint"
			@change="update"
			v-model="model"
		></checkbox-with-null-input>

		<combobox-input
			ref="input"
			v-if="input.type === 'combobox'"
			:required="input.required"
			:disabled="input.disabled"
			:label="input.label"
			:hint="input.hint"
			:rules="input.rules"
			@change="update"
			v-model="model"
			:combotype="input.combotype"
		></combobox-input>

		<number-input
			ref="input"
			v-if="input.type === 'number'"
			:required="input.required"
			:disabled="input.disabled"
			:label="input.label"
			:rules="input.rules"
			:hint="input.hint"
			@change="update"
			v-model="model"
		></number-input>

		<text-input
			:display="input.display"
			ref="input"
			v-if="input.type === 'text'"
			:required="input.required"
			:disabled="input.disabled"
			:label="input.label"
			:hint="input.hint"
			:rules="input.rules"
			@change="update"
			v-model="model"
		></text-input>

		<text-area-input
			:display="input.display"
			ref="input"
			v-if="input.type === 'text-area'"
			:required="input.required"
			:disabled="input.disabled"
			:label="input.label"
			:placeholder="input.placeholder"
			:rules="input.rules"
			@change="update"
			v-model="model"
			:hint="input.hint"
		></text-area-input>

		<file-input
			ref="input"
			v-if="input.type === 'file'"
			:required="input.required"
			:disabled="input.disabled"
			:label="input.label"
			:rules="input.rules"
			:hint="input.hint"
			@change="update"
			:accept="input.accept"
			v-model="model"
		></file-input>

		<select-input
			ref="input"
			v-if="input.type === 'select'"
			:required="input.required"
			:disabled="input.disabled"
			:label="input.label"
			:rules="input.rules"
			:hint="input.hint"
			@change="update"
			v-model="model"
			:item-text="input.itemText"
			:item-value="input.itemValue"
			:values="input.values"
		></select-input>

		<multi-select-input
			ref="input"
			v-if="input.type === 'multi-select'"
			:required="input.required"
			:disabled="input.disabled"
			:hint="input.hint"
			:label="input.label"
			:rules="input.rules"
			@change="update"
			v-model="model"
			:item-text="input.itemText"
			:item-value="input.itemValue"
			:values="input.values"
		></multi-select-input>

		<date-time-input
			ref="input"
			v-if="input.type === 'date-time'"
			:required="input.required"
			:hint="input.hint"
			:disabled="input.disabled"
			:label="input.label"
			:rules="input.rules"
			@change="update"
			v-model="model"
		></date-time-input>

		<date-input
			ref="input"
			v-if="input.type === 'date'"
			:required="input.required"
			:disabled="input.disabled"
			:label="input.label"
			:hint="input.hint"
			:rules="input.rules"
			:min="input.min"
			@change="update"
			v-model="model"
		></date-input>

		<time-input
			ref="input"
			v-if="input.type === 'time'"
			:required="input.required"
			:disabled="input.disabled"
			:hint="input.hint"
			:label="input.label"
			:rules="input.rules"
			@change="update"
			v-model="model"
		></time-input>

		<data-input
			ref="input"
			v-if="input.type === 'data'"
			:required="input.required"
			:disabled="input.disabled"
			:label="input.label"
			:rules="input.rules"
			:hint="input.hint"
			:multiple="input.multiple !== false"
			@change="update"
			v-model="model"
			:model-name="input.modelName"
		></data-input>

		<Label v-if="input.infoLabel">
			{{ typeof input.infoLabel === 'function' ? input.infoLabel() : input.infoLabel }}
		</Label>
	</v-layout>
</template>
<script>
import checkboxWithNullInput from './inputs/checkboxWithNullInput'
import CheckboxInput from './inputs/checkboxInput'
import ComboboxInput from './inputs/comboboxInput'
import NumberInput from './inputs/numberInput'
import TextInput from './inputs/textInput'
import TextAreaInput from './inputs/textAreaInput'
import FileInput from './inputs/fileInput'
import SelectInput from './inputs/selectInput'
import MultiSelectInput from './inputs/multiSelectInput'
import DateTimeInput from './inputs/dateTimeInput'
import DateInput from './inputs/dateInput'
import DataInput from './inputs/dataInput'
import TimeInput from './inputs/timeInput.vue'

export default {
	components: {
		checkboxWithNullInput,
		CheckboxInput,
		ComboboxInput,
		NumberInput,
		TextInput,
		TextAreaInput,
		FileInput,
		SelectInput,
		MultiSelectInput,
		DateTimeInput,
		DateInput,
		DataInput,
		TimeInput,
	},
	props: ['input', 'value'],
	data() {
		return {
			model: null,
		}
	},
	methods: {
		empty() {
			this.$refs.input.empty()
		},
		init() {
			if (this.value !== undefined && this.value !== null) {
				this.model = this.value
			}
		},
		update(value) {
			if (this.input.onChange) {
				this.input.onChange(this.model)
			}
			this.$emit('input', this.model)
			this.$emit('change', this.model)
		},
	},
	watch: {
		value() {
			this.init()
		},
	},
	mounted() {
		this.init()
	},
}
</script>

<style lang="scss">
.bo-input {
	position: relative;
	.v-picker {
		z-index: 2000;
		position: absolute;
	}
	label {
		align-self: center;
	}
}
</style>



// WEBPACK FOOTER //
// src/baseComponents/boInput.vue